// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  flex-grow: 1;
  align-items: stretch;
  /*justify-content: unset !important ;*/
  display: flex;
  flex-direction: column;
  /*align-items: flex-start;*/
  gap: var(--Spacings-Spacing-03, 12px);
  align-self: stretch;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  border-radius: var(--Radius-radius-l, 16px);
  /*box-shadow: 0px 2px 8px 0px rgba(0, 93, 152, 0.15);*/
}
:host(.hs-card-white) {
  background: var(--Colors-UI-Neutral-Grey-0, #FFF);
}
:host(.hs-card-grey) {
  background: var(--Colors-UI-Neutral-Grey-100, #F5F5F5);
}
/* TODO: this needs to be fixed, when edit-mode is enabled, we need to remove the padding-top, but this is failing */
:host-has(.edit-mode-enabled) {
  padding-top: 0px;
}
:host(.clickable) {
  cursor: pointer;
}
:host(.clickable:hover) {
  z-index: 1;
}
:host(.clickable:active) {
  opacity: 0.7;
}
:host(.selected) {
  z-index: 1;
}

.container {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  padding-top: 22px;
  padding-bottom: var(--Spacings-Spacing-04, 24px);
  padding-left: var(--Spacings-Spacing-04, 16px);
  padding-right: var(--Spacings-Spacing-04, 16px);
  border-radius: inherit;
  overflow: hidden;
}
.container.compact {
  padding-top: 10px;
  padding-bottom: 10px;
  gap: 0;
}
.container.compact .header {
  height: 28px;
}
.container.compact .title {
  font-size: 13px;
  height: auto;
}
.container.compact .value {
  font-size: 22px;
  line-height: 28px;
}
.container.compact .value-suffix {
  font-size: 12px;
  height: 24px;
}

.container::after {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  box-sizing: border-box;
  border-radius: inherit;
  border: 2px solid transparent;
}

:host(.clickable:hover) .container {
  background: var(--Colors-UI-Primary-Primary-Medium, #E6F2FF);
}

:host(.clickable:hover) .container::after {
  border-color: var(--Colors-UI-Primary-Primary-Dark, #0078D4);
  box-shadow: 0 4px 12px rgba(0, 50, 82, 0.1);
}

:host(.selected) .container {
  background: #eaf4ff;
}

:host(.selected) .container::after {
  border-color: #2e72b7;
  box-shadow: 0 0 0 2px rgba(46, 114, 183, 0.22);
}
.head {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  height: 100%;
  /*
  justify-content: center;
  align-items: flex-start;
  */
  /*gap: var(--Spacings-Spacing-03, 12px);*/
}

.header {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  height: 48px;
}
.icon-container {
  height: 38px;
  display: none;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.title {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 48px;
  /*min-width: 150px;*/
  align-self: stretch;
  overflow: hidden;
  color: var(--Colors-UI-Secondary-Secondary-Dark, #113E57);
  text-overflow: ellipsis;
  white-space: nowrap;
  /* Web & Mobile/Body/Bold 16pt */
  /* font-family: Inter; */
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.value-container {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
}
.value {
  color: var(--Colors-UI-Secondary-Secondary-Dark, #113E57);
  /* Web & Mobile/Title/Bold 28pt */
  /* font-family: Poppins; */
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px; /* 135.714% */
}
.value.tall {
  height: auto;
  font-size: 46px;
}
.value.small {
  font-size: 22px;
  line-height: 30px;
}
.value-suffix {
  display: flex;
  align-items: flex-end;
  color: var(--Colors-UI-Secondary-Secondary-Dark, #113E57);
  /* Web & Mobile/Title/Bold 28pt */
  /* font-family: Poppins; */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  height: 34px; /* 135.714% */
}

.footer {
  display: none;
  justify-content: space-between;
  align-items: flex-end;
  align-self: stretch;
  height: 30px;
}

.footer-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  color: var(--Colors-UI-Secondary-Secondary-Dark, #113E57);
  text-overflow: ellipsis;
  /* Web & Mobile/Body/Regular 14pt */
  /* font-family: Inter; */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.footer-value {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  color: var(--Colors-UI-Status-Success-Success-Medium, #14B814);
  text-overflow: ellipsis;
  /* Web & Mobile/Body/Regular 14pt */
  /* font-family: Inter; */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
`, "",{"version":3,"sources":["webpack://./src/metric.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,oBAAoB;EACpB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,sDAAsD;AACxD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,sDAAsD;AACxD;AACA,oHAAoH;AACpH;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,gDAAgD;EAChD,8CAA8C;EAC9C,+CAA+C;EAC/C,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,MAAM;AACR;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;EAC5D,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,YAAY;EACZ;;;GAGC;EACD,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yDAAyD;EACzD,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,yDAAyD;EACzD,iCAAiC;EACjC,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,yDAAyD;EACzD,iCAAiC;EACjC,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY,EAAE,aAAa;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,yDAAyD;EACzD,uBAAuB;EACvB,mCAAmC;EACnC,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,8DAA8D;EAC9D,uBAAuB;EACvB,mCAAmC;EACnC,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[":host {\n  flex-grow: 1;\n  align-items: stretch;\n  /*justify-content: unset !important ;*/\n  display: flex;\n  flex-direction: column;\n  /*align-items: flex-start;*/\n  gap: var(--Spacings-Spacing-03, 12px);\n  align-self: stretch;\n  box-sizing: border-box;\n  position: relative;\n  overflow: hidden;\n  border-radius: var(--Radius-radius-l, 16px);\n  /*box-shadow: 0px 2px 8px 0px rgba(0, 93, 152, 0.15);*/\n}\n:host(.hs-card-white) {\n  background: var(--Colors-UI-Neutral-Grey-0, #FFF);\n}\n:host(.hs-card-grey) {\n  background: var(--Colors-UI-Neutral-Grey-100, #F5F5F5);\n}\n/* TODO: this needs to be fixed, when edit-mode is enabled, we need to remove the padding-top, but this is failing */\n:host-has(.edit-mode-enabled) {\n  padding-top: 0px;\n}\n:host(.clickable) {\n  cursor: pointer;\n}\n:host(.clickable:hover) {\n  z-index: 1;\n}\n:host(.clickable:active) {\n  opacity: 0.7;\n}\n:host(.selected) {\n  z-index: 1;\n}\n\n.container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  box-sizing: border-box;\n  padding-top: 22px;\n  padding-bottom: var(--Spacings-Spacing-04, 24px);\n  padding-left: var(--Spacings-Spacing-04, 16px);\n  padding-right: var(--Spacings-Spacing-04, 16px);\n  border-radius: inherit;\n  overflow: hidden;\n}\n.container.compact {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  gap: 0;\n}\n.container.compact .header {\n  height: 28px;\n}\n.container.compact .title {\n  font-size: 13px;\n  height: auto;\n}\n.container.compact .value {\n  font-size: 22px;\n  line-height: 28px;\n}\n.container.compact .value-suffix {\n  font-size: 12px;\n  height: 24px;\n}\n\n.container::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  box-sizing: border-box;\n  border-radius: inherit;\n  border: 2px solid transparent;\n}\n\n:host(.clickable:hover) .container {\n  background: var(--Colors-UI-Primary-Primary-Medium, #E6F2FF);\n}\n\n:host(.clickable:hover) .container::after {\n  border-color: var(--Colors-UI-Primary-Primary-Dark, #0078D4);\n  box-shadow: 0 4px 12px rgba(0, 50, 82, 0.1);\n}\n\n:host(.selected) .container {\n  background: #eaf4ff;\n}\n\n:host(.selected) .container::after {\n  border-color: #2e72b7;\n  box-shadow: 0 0 0 2px rgba(46, 114, 183, 0.22);\n}\n.head {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n  height: 100%;\n  /*\n  justify-content: center;\n  align-items: flex-start;\n  */\n  /*gap: var(--Spacings-Spacing-03, 12px);*/\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 8px;\n  height: 48px;\n}\n.icon-container {\n  height: 38px;\n  display: none;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.title {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 48px;\n  /*min-width: 150px;*/\n  align-self: stretch;\n  overflow: hidden;\n  color: var(--Colors-UI-Secondary-Secondary-Dark, #113E57);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  /* Web & Mobile/Body/Bold 16pt */\n  /* font-family: Inter; */\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.value-container {\n  display: flex;\n  justify-content: flex-start;\n  gap: 10px;\n}\n.value {\n  color: var(--Colors-UI-Secondary-Secondary-Dark, #113E57);\n  /* Web & Mobile/Title/Bold 28pt */\n  /* font-family: Poppins; */\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 38px; /* 135.714% */\n}\n.value.tall {\n  height: auto;\n  font-size: 46px;\n}\n.value.small {\n  font-size: 22px;\n  line-height: 30px;\n}\n.value-suffix {\n  display: flex;\n  align-items: flex-end;\n  color: var(--Colors-UI-Secondary-Secondary-Dark, #113E57);\n  /* Web & Mobile/Title/Bold 28pt */\n  /* font-family: Poppins; */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  height: 34px; /* 135.714% */\n}\n\n.footer {\n  display: none;\n  justify-content: space-between;\n  align-items: flex-end;\n  align-self: stretch;\n  height: 30px;\n}\n\n.footer-title {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  color: var(--Colors-UI-Secondary-Secondary-Dark, #113E57);\n  text-overflow: ellipsis;\n  /* Web & Mobile/Body/Regular 14pt */\n  /* font-family: Inter; */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.footer-value {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  color: var(--Colors-UI-Status-Success-Success-Medium, #14B814);\n  text-overflow: ellipsis;\n  /* Web & Mobile/Body/Regular 14pt */\n  /* font-family: Inter; */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
